<!-- vertical layout-->
<app-vertical *ngIf="isVerticalLayoutRequested() && isLoad"></app-vertical>

<!-- horizontal layout-->
<app-horizontal *ngIf="isHorizontalLayoutRequested() && isLoad" [isMenuVisible]="isMenuVisible"></app-horizontal>
